import React, { memo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Button,
  Icon,
  Stack,
  Tooltip,
  IconButton,
  useMediaQuery
} from 'investira.react.components';
import { AvaliacoesTemplate } from '../../components/templates';
import AvaliacoesHighlights from './AvaliacoesHighlights';
import usePerfil from '../../hooks/usePerfil';
import { useAvaliacoesContext } from '../../contexts/AvaliacoesContext';
import withAvaliacoes from '../../hoc/withAvaliacoes';

const Avaliacoes = memo(props => {
  const navigate = useNavigate();
  const location = useLocation();

  const { actions } = useAvaliacoesContext();
  const isUpSm = useMediaQuery(theme => theme.breakpoints.up('sm'));
  const { usuarioPrioridade } = usePerfil();

  return (
    <AvaliacoesTemplate
      title={'Avaliações de Fundos e Gestores'}
      subtitle={props.subtitle}
      description="Gerenciar processos de due diligence para gestores de ativos com base nos padrões ANBIMA QDD."
      maxWidth={'xl'}
      headerRenderActions={
        usuarioPrioridade <= 6 && (
          <Stack direction="row" spacing={2}>
            <Button
              disabled={props.disabledButtons}
              variant="contained"
              color="primary"
              startIcon={<Icon iconName="insert" size={16} />}
              size="small"
              sx={{ px: 2 }}
              onClick={() => {
                actions.handleResetState();
                navigate('/avaliacoes/add');
              }}>
              {isUpSm ? 'Nova Avaliação' : 'Avaliação'}
            </Button>
            <Tooltip title={`Configurações`}>
              <IconButton
                color="primary"
                size="small"
                onClick={() => navigate(`${location.pathname}/configuracoes`)}>
                <Icon iconName="gear" size={24} />
              </IconButton>
            </Tooltip>
          </Stack>
        )
      }
      dataGridProps={{
        data: props.avaliacoes,
        readData: props.readAvaliacoes,
        isLoading: props.isLoading,
        initialState: { pagination: props.pagination },
        manualPagination: true,
        getRowId: row => {
          return row.avaliacao_id;
        },
        state: {
          isLoading: props.isLoading,
          pagination: props.pagination,
          showProgressBars: props.isRefetching,
          rowSelection: props.rowSelection
        },
        rowCount: props.rowCount,
        onPaginationChange: props.setPagination,
        onRowSelectionChange: props.setRowSelection
        // onEditClick: actions.handleEditCarteira,
        // onDeleteClick: props.deleteCarteira,
        // onBulkDeleteClick: props.bulkDeleteCarteiras,
      }}>
      <AvaliacoesHighlights />
    </AvaliacoesTemplate>
  );
});

Avaliacoes.displayName = 'Avaliacoes';

export default withAvaliacoes(Avaliacoes);
